export enum RoomDetailVariant {
  RoomPage = 'RoomPage',
  LandingPage = 'LandingPage',
}

export const RoomDetailContainerJustifyContent = {
  [RoomDetailVariant.RoomPage]: 'flex-start',
  [RoomDetailVariant.LandingPage]: 'space-between',
};
export const RoomDetailContainerCarousel = {
  [RoomDetailVariant.RoomPage]: 4,
  [RoomDetailVariant.LandingPage]: 5.7,
};

export const RoomDetailContainerDescription = {
  [RoomDetailVariant.RoomPage]: 4,
  [RoomDetailVariant.LandingPage]: 5.7,
};

export const RoomDetailMarginCarouselRight = {
  [RoomDetailVariant.RoomPage]: "0px 0px 0px 3%",
  [RoomDetailVariant.LandingPage]: '0px',
};
export const RoomDetailMarginCarouselLeft = {
  [RoomDetailVariant.RoomPage]: "0px 3% 0px 0px",
  [RoomDetailVariant.LandingPage]: '0px',
};


